$(document).ready(function() {

  let nowTemp = new Date();
  let now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

  function getLocale() {
    const localeMeta = document
      .querySelector('meta[name="language"]')
      .getAttribute("content");
    return localeMeta ? localeMeta : "ru";
  }

  let checkin = $('#startDate').datepicker({
    maxDate: new Date(),
    defaultDate: '-1m',
    minDate: new Date('-5y'),
    dateFormat: 'dd.mm.yyyy',
    format: 'dd.mm.yyyy',
    language: getLocale(),
    container: '#startDateInputGroup',
  }).on('changeDate', function (event) {
    if (event.date && checkout.date && event.date.valueOf() > checkout.date.valueOf()) {
      let newDate = new Date(event.date);

      newDate.setDate(newDate.getDate() + 1);
      checkout.setValue(newDate);
    }
    checkin.hide();
    $('#finishDate')[0].focus();
  }).data('datepicker');

  let checkout = $('#finishDate').datepicker({
    maxDate: new Date(),
    minDate: new Date('-5y'),
    dateFormat: 'dd.mm.yyyy',
    format: 'dd.mm.yyyy',
    language: getLocale(),
    container: '#finishDateInputGroup',
  }).on('changeDate', function (event) {
    checkout.hide();
  }).data('datepicker');

  $('#get-statistics').click(function (event) {
    let startDate = $('#startDate');
    let finishDate = $('#finishDate');
    let mayPick = true;

    if (startDate.val() == '') {
      $(startDate)[0].focus();
      mayPick = false;
    }
    else if (finishDate.val() == '') {
      $(finishDate)[0].focus();
      mayPick = false;
    }

    if (!mayPick) {
      event.preventDefault();
    }
  });

  $('#startDate').datepicker("setDate",$('#startDate').val());
  $('#finishDate').datepicker("setDate",$('#finishDate').val());
});
